<template>
	<div>
		<v-list dense rounded v-if="data">
			<v-list-item v-if="!isEditing">
				<v-list-item-content>
					<v-file-input
						:disabled="isEditing"
						v-model="data.file"
						label="Select file for upload"
						prepend-icon="mdi-attachment"
						show-size
					/>
				</v-list-item-content>
			</v-list-item>
			<v-list-item>
				<v-list-item-content>
					<v-text-field
						:rules="[(v) => !!v || 'Title is mandatory']"
						class="fullwidth"
						filled
						label="Title"
						prepend-icon="mdi-file-document"
						required
						v-model="data.name"
					></v-text-field>
				</v-list-item-content>
			</v-list-item>
		</v-list>
	</div>
</template>

<script>
export default {
	name: 'FileForm',
	data() {
		return {
			isEditing: false,
		}
	},
	mounted() {
		const { name, path, filetype } = this.data
		if (name && path && filetype) this.isEditing = true
	},
	props: {
		data: {
			type: Object,
			default: {
				name: '',
				path: '',
				filetype: '',
				text: '',
			},
		},
	},
}
</script>

<style lang="scss" scoped>
</style>